import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStudioDisplay: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconStudioDisplay"><Path fillRule="evenodd" clipRule="evenodd" d="M2 6.5C2 5.11929 3.11929 4 4.5 4H19.5C20.8807 4 22 5.11929 22 6.5V15.5C22 16.8807 20.8807 18 19.5 18H16V20.5C16 20.7761 15.7761 21 15.5 21H8.5C8.22386 21 8 20.7761 8 20.5V18H4.5C3.11929 18 2 16.8807 2 15.5V6.5ZM9 18V20H15V18H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStudioDisplay;
